import React, {useEffect, useState} from 'react';
import EditorPreview from '../../../EditorPreview';
import {InteractionsMenuItem} from '../../InteractionsMenuItems';
import AnimatedUploadingFilePopUp from '../../../AnimatedUploadingFilePopUp';
import AbstractModalView from '../../../AbstractModalView';
import edit from '../../../../assets/brush-4A4A4A.svg';
import styles from '../../../ImagePreview/styles.module.scss';

const EditImage = ({
                     fileTypeID,
                     orderFileTypeID,
                     fileID,
                     content,
                     fileName,
                     uploadFile,
                     uploadOrderFile,
                     updateFile,
                     getFileList,
                     setClickOutsideAllowed,
                     closeDropdown,
                     itemProps,
                     shumaId,
                     orderID,
                     isFileFromOrder,
                     editFormValues
                   }) => {
  const [loading, setLoading] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);

  const getImageSrc = image => {
    switch (typeof image) {
      case 'string':
        setImageSrc(image);
        break;
      case 'object':
      default:
        readDataURL(image);
    }
  };
  const readDataURL = file => {
    const reader = new FileReader();
    reader.onload = () => {
      setImageSrc(reader.result);
    };
    reader.onerror = function (error) {
      setImageSrc(null);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };
  useEffect(() => {getImageSrc(content)}, [content]);

  const handleOpenModal = async (openModal) => {
    closeDropdown();
    if (!Boolean(content)) {
      setLoading(true);
      await updateFile();
    }
    setClickOutsideAllowed(false);
    setLoading(false);
    openModal();
  };

  const save = (image, payload) => {
    if (isFileFromOrder) {
      uploadOrderFile({
        shumaId,
        orderID,
        fileID,
        filename: fileName,
        fileTypeId: fileTypeID,
        orderFileTypeID,
        fileToSave: payload.modifiedImage
      })
        .then(() => getFileList({shumaId}))
        .then(() => setClickOutsideAllowed(true))
        .finally(closeDropdown);
    } else {
      uploadFile({
        shumaId,
        fileID,
        filename: fileName,
        fileTypeId: fileTypeID,
        fileToSave: payload.modifiedImage,
        freeID: editFormValues.freeID ? editFormValues.freeID : 0,
        freeText: editFormValues.freeText ? editFormValues.freeText : '',
      })
        .then(() => getFileList({shumaId}))
        .then(() => setClickOutsideAllowed(true))
        .finally(closeDropdown);
    }

  };
  const handleConfirm = closeModal => payload => {
    if (save) {
      save(content, payload);
    }
    closeModal();
  };

  const reject = () => setClickOutsideAllowed(true);
  const handleCancel = closeModal => () => {
    if (reject) {
      reject();
    }
    closeModal();
  };

  return (
    <>
      <AnimatedUploadingFilePopUp show={loading}/>
      <AbstractModalView
        subPath={`image-preview-${fileID}`}
        triggerContent={({openModal, closeModal}) => (
          <InteractionsMenuItem
            label={'עריכה'}
            icon={edit}
            onClick={() => handleOpenModal(openModal, closeModal)}
            customClassnames={styles.interactionsMenuItemTop}
            {...itemProps[0]}
          />
        )}
        modalContent={({closeModal}) => (
          <div className={styles.modalContentContainer}>
            <EditorPreview
              imageSrc={imageSrc}
              onConfirm={handleConfirm(closeModal)}
              onReject={handleCancel(closeModal)}
            />
          </div>
        )}
        onCloseModal={handleCancel}
        modalClassName={styles.modal}
      />
    </>
  );
};

export default EditImage;